import React from "react";
import { BoxProps, CircularProgress, CircularProgressProps, SxProps } from "@mui/material";

import { BlockSpinnerContainer } from "./BlockSpinner.styles";

type BlockSpinnerProps = BoxProps & {
  containerProps?: SxProps;
  spinnerProps?: CircularProgressProps;
};

const BlockSpinner: React.FC<BlockSpinnerProps> = ({ containerProps, spinnerProps, ...rest }: BlockSpinnerProps) => {
  return (
    <BlockSpinnerContainer sx={containerProps} {...rest} data-testid="loading-spinner">
      <CircularProgress className="spinner" {...spinnerProps} />
    </BlockSpinnerContainer>
  );
};

export default BlockSpinner;
